import { animate, style, transition, trigger } from '@angular/animations';

// const listAnimation = trigger('listAnimation', [
//   transition('* <=> *', [
//     query(':enter',
//       [style({ opacity: 0 }), stagger('60ms', animate('600ms ease-out', style({ opacity: 1 })))],
//       { optional: true }
//     ),
//     query(':leave',
//       animate('200ms', style({ opacity: 0 })),
//       { optional: true }
//     )
//   ])
// ]);

export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    // style({ opacity: 0 }), animate('1s', style({ opacity: 1 }))]
     style({transform: 'translateX(100vw)'}), animate('600ms ease-out', style({transform: 'translateX(0%)'}))]

  ),
  // transition(':leave',
  //   [style({ opacity: 1 }), animate('300ms', style({ opacity: 0 }))]
  // )
]);
